import { h } from "preact";
import { Link } from "preact-router/match";
import style from "./style.scss";
import "../../style/bgimgs.scss";
import "../../style/bgAnimations.css";
import { useEffect } from "preact/hooks";

const Home = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <main>
        <div class={style.home}>
          <div class={style.hdrbgfr}>
            <div class="headerimage revbgsm" />
            <h1 itemprop="name" class="revh1">
              DIE VIELFALT <br /> DER THERMOPLASTE
            </h1>
          </div>
          <meta itemprop="datePublished" content="2022-12-13T08:00:00+08:00" />
          <meta itemprop="dateModified" content="2022-12-13T08:00:00+08:00" />
          <meta itemprop="lastReviewed" content="2022-12-13T08:00:00+08:00" />
          <span itemprop="primaryImageOfPage" itemscope="">
            <link itemprop="url" href="/assets/logos/logo600x600.png" />
          </span>

          <section class="headerimage2">
            <div class={style.cardouter}>
              <div class={style.cardfr}>
                <h2>ÜBER UNS</h2>
                <p itemprop="description">
                  Über 20 Jahre Know-how in der Kunststoffindustrie. Gemeinsam
                  mit Ihnen finden wir die beste technische Lösung für Ihr
                  Kunststoff-Endprodukt.
                </p>
              </div>
              <div class={style.clfl}>
                <Link href="/about">MEHR ÜBER UNS</Link>
              </div>
            </div>
          </section>

          <section class="headerimage3">
            <div class={style.cardouter}>
              <div class={style.cardfr}>
                <h2>IHR WEG ZU UNS</h2>
              </div>
              <div class={style.clfr}>
                <Link href="/kontakt">KONTAKT</Link>
              </div>
            </div>
          </section>

          <section class="headerimage4">
            <div class={style.cardouter}>
              <div class={style.cardfr}>
                <h2>DER SCHNELLSTE WEG ZUR BESTEN BETREUUNG!</h2>
              </div>
              <div class={style.clfl}>
                <a href="tel:+41714404444">+41 (0) 71 440 44 44</a>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default Home;
